<template>
  <div>
    <!-- 顶部查询面板 -->
    <div class="top-operate-container">
      <el-form :inline="true" :model="searchFormData" class="operate-form" :disabled="loading">
        <el-form-item :label="$str.getKey('收益管理/日期')">
          <el-date-picker v-model="searchFormData.timer" type="month" value-format="YYYY-MM" :clearable="false"
            :disabled-date="disabledHalfYear" @change="timeRangeChange" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getListData">{{ $str.getKey('收益管理/查询') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="mt-[40px]">
      <div style="display: flex; flex-flow: row; justify-content: space-between">
        <div class="title-text">{{ $str.getKey('收益管理/储能电站能源管理通知单') }}</div>
        <div class="title-btn-bottom">
          <el-button type="primary" class="btn-print" @click="printFunc(tableRef)">
            <el-icon style="margin-right: 6px">
              <Printer />
            </el-icon>{{ $str.getKey('收益管理/打印') }}
          </el-button>
          <el-button type="primary" class="btn-print" @click="exportTable('printTableB')">
            <el-icon style="margin-right: 6px">
              <Upload />
            </el-icon>{{ $str.getKey('收益管理/导出') }}
          </el-button>
        </div>
      </div>

      <div ref="tableRef" class="panel-content">
        <table class="print-panel-table" :border="1" cellspacing="0" id="printTableB">
          <!-- 标题 -->
          <tbody>
            <tr>
              <td colspan="8" style="font-size: 18px;">{{ searchFormData.timer + stationName + $str.getKey('收益管理/电费通知单') }}</td>
            </tr>
          </tbody>
          <!-- 表头 -->
          <tbody>
            <tr>
              <td>{{ $str.getKey('收益管理/电表名称') }}</td>
              <td>{{ $str.getKey('收益管理/功率') }}</td>
              <td>{{ cfg.showReadingDate ? $str.getKey('收益管理/上月读数') + '(' + firstDay + ')' : $str.getKey('收益管理/上月读数') }}</td>
              <td>{{ cfg.showReadingDate ? $str.getKey('收益管理/本月读数') + '(' + lastDay + ')' : $str.getKey('收益管理/本月读数') }}</td>
              <td>{{ $str.getKey('收益管理/倍率') }}</td>
              <td>{{ $str.getKey('收益管理/计费电量') }}</td>
              <td v-if="cfg.showOriginElecQuantity">{{ $str.getKey('收益管理/电量数据') }}</td>
              <td>{{ $str.getKey('收益管理/市电电价') }}</td>
              <td>{{ $str.getKey('收益管理/电费(元)') }}</td>
            </tr>
          </tbody>
          <!-- 各电表明细 -->
          <tbody v-for="(tableItem, index) in totalAllData.meters" :key="index">
            <tr v-for="(item, rowIdx) in tableList[index]" :key="rowIdx">
              <td width="180">
                {{ cfg.showDevId ? (item.meterName ? item.meterName + '(' + item.devId + ')' : '') : item.meterName }}
              </td>
              <td width="150">{{ item.itemLabel }}</td>
              <td width="150">{{ item.lastReading }}</td>
              <td width="150">{{ item.currReading }}</td>
              <td width="100">{{ item.rate }}</td>
              <td width="100">{{ item.billQty }}</td>
              <td width="100" v-if="cfg.showOriginElecQuantity">{{ item.elecData }}</td>
              <td width="100">{{ item.price }}</td>
              <td width="100">{{ item.fee }}</td>
            </tr>
          </tbody>
          <!-- 底部汇总:海四达样式 -->
          <tbody v-if="cfg.summaryType === 'haisida'">
            <tr>
              <td colspan="4" style="font-size: 18px">{{ $str.getKey('收益管理/本期系统总收益：') }}</td>
              <td colspan="4">{{ countAllData }}</td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 18px">{{ $str.getKey('收益管理/本期甲方应向支付乙方储能电费合计人民币：') }}</td>
              <td colspan="4"></td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 18px">{{ $str.getKey('收益管理/实收电费人民币(大写)：') }}</td>
              <td colspan="4"></td>
            </tr>
          </tbody>
          <!-- 底部汇总:默认(津西/通用)样式 -->
          <tbody v-else>
            <tr>
              <td colspan="4" style="font-size: 18px">{{ $str.getKey('收益管理/甲方实际支付乙方储能电费合计人民币：') }}</td>
              <td colspan="4">{{ countAllData }}</td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 18px">{{ $str.getKey('收益管理/实收电费人民币(大写)：') }}</td>
              <td colspan="4"></td>
            </tr>
          </tbody>
          <!-- 备注 -->
          <tbody>
            <tr>
              <td colspan="8" align="left">
                <div v-for="(item, idx) in remarkInfoList" :key="idx">{{ item }}</div>
              </td>
            </tr>
          </tbody>
          <!-- 签署栏:甲乙方盖章 -->
          <tbody v-if="cfg.signerType === 'party'">
            <tr>
              <td colspan="2">{{ $str.getKey('收益管理/甲方（签字或盖章）：') }}</td>
              <td colspan="2"></td>
              <td colspan="2">{{ $str.getKey('收益管理/乙方（签字或盖章）：') }}</td>
              <td colspan="2"></td>
            </tr>
          </tbody>
          <!-- 签署栏:奇电公司 -->
          <tbody v-else>
            <tr>
              <td colspan="2">{{ $str.getKey('收益管理/运维制表') }}</td>
              <td colspan="2">{{ (totalAllData.overview && totalAllData.overview.fullName2) || $str.getKey('收益管理/江门市奇电能源科技投资有限公司') }}</td>
              <td colspan="2">{{ $str.getKey('收益管理/购电审核') }}</td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from "vue";
import dayjs from "dayjs";
import { getIncomeData } from "./api/index.js";
import useAppStore from "@/store/modules/app";
import { METER_TEMPLATES, buildMeterRows, TOTAL_ROW_INDEX } from "./config/meterTemplates.js";
import { getMonthRange, disabledHalfYear, normalizeOverview } from "./shared/statementData.js";
import { printElement, exportTableToExcel } from "./shared/statementExport.js";

const $str = window.$str;

const props = defineProps({
  // 模板标识:jingxi(津西) | common(通用) | haisida(海四达)
  templateKey: { type: String, required: true },
  stationId: [Number, String],
  remark: String
});

/** 当前模板配置 */
const cfg = computed(() => METER_TEMPLATES[props.templateKey] || METER_TEMPLATES.common);

const appStore = useAppStore();
/** 从 store 获取 stationId / stationName,并监听变化刷新 */
const stationId = computed(() => appStore.stationId);
const stationName = computed(() => appStore.stationName);

const loading = ref(false);
const totalAllData = ref([]);
const tableList = ref([]);
const countAllData = ref(0);
const tableRef = ref(null);
const firstDay = ref("");
const lastDay = ref("");

const searchFormData = reactive({
  timer: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM")
});

const remarkInfoList = computed(() => cfg.value.remarks());

watch(() => appStore.stationId, newStationId => {
  if (newStationId) {
    getListData();
  }
}, { immediate: true });

onMounted(() => {
  getListData();
});

function getListData() {
  const { firstDay: first, lastDay: last } = getMonthRange(searchFormData.timer);
  firstDay.value = first;
  lastDay.value = last;
  totalAllData.value = [];
  loading.value = true;

  getIncomeData({
    startDate: first,
    endDate: last,
    stationId: stationId.value
  }).then(res => {
    totalAllData.value = JSON.parse(JSON.stringify(res.data));
    normalizeOverview(totalAllData.value.overview);
    totalAllData.value.startDate = first;
    totalAllData.value.endDate = last;
    countAllData.value = 0;
    formatterMetersData(totalAllData.value.meters);
  }).catch(err => {
    console.error(err);
    countAllData.value = 0;
  }).finally(() => {
    loading.value = false;
  });
}

/** 构建各电表明细 + 累加合计 */
function formatterMetersData(metersData = []) {
  tableList.value = [];
  countAllData.value = 0;
  metersData.forEach(item => {
    const rows = buildMeterRows(item, cfg.value);
    tableList.value.push(rows);
    const val = Number(rows[TOTAL_ROW_INDEX].fee === "/" ? 0 : rows[TOTAL_ROW_INDEX].fee);
    const sum = countAllData.value + val;
    countAllData.value = cfg.value.roundCountAll ? sum.toFixed(4) / 1 : sum;
  });
}

/** 月份变化:刷新数据(统一各模板行为) */
function timeRangeChange(val) {
  searchFormData.timer = val;
  getListData();
}

/** 打印 */
function printFunc(el) {
  printElement(el);
}

/** 导出 */
function exportTable(id) {
  exportTableToExcel(id, "抄表详情");
}
</script>

<style lang="scss" scoped>
.remark-info-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  color: #696868;

  .info-text {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 14px;
    line-height: 38px;
    text-align: left;
  }
}

table,
table tr th,
table tr td {
  color: #9d9ea0;
  border: 1px solid #525151;
}

table {
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
  width: 1050px;
}

.title-text {
  line-height: 26px;
  font-size: 18px;
  border-left: 10px solid blue;
  padding-left: 10px;
  margin-bottom: 10px;
}

.panel-content {
  margin-top: 20px;
}

.title-btn-bottom {
  position: relative;
  right: 27px;
}

// 查询/打印/导出按钮:系统统一主色
:deep(.el-button--primary),
:deep(.btn-print) {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
  color: #fff !important;

  span,
  .el-icon {
    color: #fff !important;
  }
}
</style>
